import React, { useCallback } from "react";
import styled from "styled-components";
import date from "utils/date";
import { hoverTips } from "utils/mixin";
import data from "services/data";
import Button from "./button";

const StyledProfile = styled.div`
  width: 100%;
  padding: 20px 15px;

  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
`;

const StyledAvatar = styled.div`
  height: 110px;
  width: 130px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.backgroundColor};
  background-color: ${({ theme }) => theme.backgroundColor};
`;

const StyledName = styled.div`
  color: ${({ theme }) => theme.dark};
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize.normal};
  letter-spacing: 1.5px;
`;

const StyledDateContainer = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  color: ${({ theme }) => theme.black};
`;

const StyledDate = styled.div`
  ${({ theme, tips }) => hoverTips(theme, tips, "0", "-120%")};
`;

const StyledTime = styled.div`
  ${({ theme, tips }) => hoverTips(theme, tips, "0", "-120%")};
`;

const Profile = ({ user, onLogout }) => {
  const name = user?.userName;
  const loginDate = user?.loginDate;

  const handleLogout = useCallback(() => {
    onLogout && onLogout();
  }, [onLogout]);

  return (
    <StyledProfile>
      <StyledAvatar></StyledAvatar>
      <StyledName>{name}</StyledName>
      <StyledDateContainer>
        <StyledDate tips="登录日期">
          {loginDate && date.formatTime("yyyy-MM-dd", loginDate)}
        </StyledDate>
        <StyledTime tips="登录时间">
          {loginDate && date.formatTime("hh:mm:ss", loginDate)}
        </StyledTime>
      </StyledDateContainer>
      <Button messageArea={false} onClick={handleLogout}>
        注销
      </Button>
    </StyledProfile>
  );
};

export default Profile;
